const OUTPUT = {
  duration: {
    id: "duration",
    output_id: "RLDUR",
    descricao: "Duration",
  },
  var: {
    id: "var",
    output_id: "RLVAR",
    descricao: "VaR",
  },
  enquadramento: {
    id: "enquadramento",
    output_id: "RLENQ",
    descricao: "Enquadramento",
  },
  raiox: {
    id: "raiox",
    output_id: "RLRAX",
    descricao: "Raio X",
  },
  rentabilidade: {
    id: "rentabilidade",
    output_id: "RLREN",
    descricao: "Rentabilidade",
  },

  stresstest: {
    id: "stresstest",
    output_id: "RLSTR",
    descricao: "Stress Test",
  },
  backtesting: {
    id: "backtesting",
    output_id: "RLBAC",
    descricao: "Back Testing",
  },
  fronteiraeficiente: {
    id: "fronteiraeficiente",
    output_id: "RLFEF",
    descricao: "Fronteira Eficiente",
  },
};

export default OUTPUT;
